import { PageContext } from './PageContext';
import { SubmissionContext } from './SubmissionFormContext';
import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle,faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import parse from 'html-react-parser';

export const SubmitNewAdOrder=()=>{
    const pageContext=useContext(PageContext);
    const subContext=useContext(SubmissionContext);
    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        {subContext?.submitForm && subContext?.submitForm.subType!="SP"?
        (<><FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="NewOrder")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitUploadPickup")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span></>)
        :
        (<><FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="NewOrder")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitUploadPickup")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span></>)
        }
    </div>
    )
}

export const SubmitNewSpecOrder=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="NewOrder")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitUploadPickup")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}


export const SubmitPickupInfo=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitUploadPickup")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitUploadPickup")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}

export const SubmitPickupToInfo=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="PickupTo")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="PickupTo")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}

export const SubmitUploadFiles=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitUploadFiles")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitUploadFiles")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}

export const SubmitInstructionsInfo=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitInstructions")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitInstructions")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}

export const SubmitCustomInfo=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitCustomQuestions")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitCustomQuestions")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}

export const SubmitSummaryInfo=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitSummary")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitSummary")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}

export const SubmitAnnotation=()=>{
    const pageContext=useContext(PageContext);

    return(
    <div className="rounded bg-primary text-white p-3 mb-3">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage"></span>{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitAnnotations")?.Prompt||"")}<span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitAnnotations")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
    </div>
    )
}